import { useState } from "react";

export const useAddMenu = () => {
  const [showAddMenu, setShowAddMenu] = useState(false);

  const handleShowAddMenu = (show: boolean) => {
    setShowAddMenu(show);
  };

  const handleAddWithMenuClose = (addAction: () => void) => {
    addAction();
    setShowAddMenu(false);
  };

  return {
    showAddMenu,
    handleShowAddMenu,
    handleAddWithMenuClose,
  };
};
